
<div>
    <div :style="{width: (width*perRow) + 'px'}">
        <div v-for="_ in circlesNumber">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-circle float-left" :style="{ width: width + 'px' }" viewBox="0 0 24 24" stroke-width="1.5" stroke="none" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                <circle cx="12" cy="12" r="9" :fill="color"/>
            </svg>
        </div>
    </div>
    <span v-if="numberOver" :style="{color: color}" class=" float-left text-left number_over">
        {{ $tc("supplierDetail.concurrency.table.data.more", numberOver) }}
    </span>
</div>
